import { useOutletContext, useParams } from "react-router";
import PipelineSettings from "../../components/template-modules/PipelineSettings";
import { IAppDetails } from "../../types";


const AppSettingsPipeline = () => {
    const { appName } = useParams();
    const { appDetails } = useOutletContext<{ appDetails: IAppDetails }>();

    return (
        <PipelineSettings pipelineId={appDetails.pipelineId || appName!} />
    );
}

export default AppSettingsPipeline;